const customerTypes = {
  PERSON: 'person',
  COMPANY: 'company',
  CONTACT_PERSON: 'contact_person'
}

customerTypes.ALL = [customerTypes.PERSON, customerTypes.COMPANY, customerTypes.CONTACT_PERSON]

export { customerTypes }
